import { selectBuildingPurchaseLevelRequirement } from "../../../../selectors/selectExistingBuildingInfo";
export var checkBuildingPurchaseHasEnoughLevel = function (path) { return function (action, state$) {
    var building = action.building;
    var state = state$.value;
    var missingLevelRequirement = selectBuildingPurchaseLevelRequirement(state, building);
    if (missingLevelRequirement.missingPlayerLevel > 0 ||
        missingLevelRequirement.missingPlayerAdventureLevel > 0) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingPurchaseHasEnoughLevel.ts
// module id = 2060
// module chunks = 3